import fetchApi from './api';
import {ApiResponse, LoginResponse, SearchPaging} from 'models/model';
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

export const LogGetPaging = async (searchPaging?: {
    pageIndex: number | null;
    pageSize: number | null;
    freeTextSearch: string;
    action: number | null;
    recordId: string | null;
    startDate: string | null;
    endDate: string | null
}): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/AuditLog/GetPaging', {
        method: 'POST',
        body: searchPaging ? JSON.stringify(searchPaging) : '{}'
    });
};